<template>
    <div class="bordas total-leitos pt-0">
        <span>Total de Leitos: {{info.length}}</span>
    </div>
</template>

<script>
export default {
    computed: {
        listagemMapaLeitos () {
            return this.$store.getters['leitos/getListagemMapaLeitos']
        },
        enfermariaSelecionada () {
            return this.$store.getters['filtro/getEnfermariaSelecionada']
        },
        info () {
            let info = this.listagemMapaLeitos.dados
            if (this.enfermariaSelecionada != '') info = info.filter(i => i.leitoNomeEnfermaria == this.enfermariaSelecionada)
            return info
        },
    }
}
</script>


<style>
    .total-leitos {
        text-align: center;
        border-top: none!important;
    }
</style>

